---
meta:
  - title: Importar playbook - IUSPRO Docs
  - description: Aprende a importar playbooks existentes.
---

# Importar playbook

Si ya tiene una guía o documento con los requisitos que debe cumplir un tipo de documento, puede importarlo en lugar de crear el playbook desde cero.

## Formatos aceptados

Puede importar playbooks desde:

- **PDF**
- **Word (DOC/DOCX)**
- **Texto plano**

## Como importar un playbook

1. **Vaya a "Playbooks"**
2. **Haga clic en "Nuevo Playbook"**
3. **Seleccione "Importar"**
4. **Elija cómo importar**:
   - Subir un archivo (PDF, Word)
   - Pegar el texto directamente

## ¿Qué hace el sistema?

Cuando importa un archivo o pega texto:

1. El sistema lee el contenido
2. Identifica automáticamente las reglas
3. Crea la estructura del playbook con:
   - Posición inicial para cada regla
   - Alternativas (si las identifica)
   - No aceptables (si los identifica)

**Todo esto se hace automáticamente**. No tiene que formatear nada especial.

## Después de importar

Una vez importado, puede:

- Revisar las reglas generadas
- Editar cualquier regla si es necesario
- Añadir más reglas manualmente
- Eliminar reglas que no necesite

## Tipo de documentos que puede importar

Cualquier documento que describa requisitos o criterios:

- Guías internas de su firma
- Listas de verificación (checklists)
- Documentos con estándares de calidad
- Manuales de procedimientos
- Plantillas con instrucciones

## Consejos para mejores resultados

Para que el sistema identifique mejor las reglas:

- **Use estructura clara** en su documento original
- **Separe cada requisito** en su propio párrafo o punto
- **Sea específico** en cada requisito

Pero no se preocupe demasiado: el sistema es bastante bueno identificando reglas incluso en documentos no perfectamente estructurados.

## Ventaja de importar

Ahorra mucho tiempo si ya tiene la documentación. En lugar de copiar regla por regla manualmente, el sistema lo hace por usted en segundos.
